import { PropsWithChildren } from 'react';
import { modalBody } from '../../../../../styled-system/recipes';

export const ModalBody = ({ children }: PropsWithChildren) => {
  return <div className={modalBody()}>{children}</div>;
};
